import { ContractLineItem, ContractLineItemPricingFragment } from "../../../Utilities";
import { ContractLineItemFormValues } from "../../FormUtilities";

export function calculateTotalAmount(contractLineItem: ContractLineItemPricingFragment) {
	let total = getSignedAmount(contractLineItem);
	for (let i = 0; i < contractLineItem.childContractLineItems.length; i++) {
		total += getSignedAmount(contractLineItem.childContractLineItems[i]);
	}
	return total;
}

export function getSignedAmount(contractLineItem: Pick<ContractLineItem, "isDiscount" | "amount">) {
	return contractLineItem.isDiscount ? -1 * contractLineItem.amount : contractLineItem.amount;
}

export function calculateTotalFormAmount(
	formValues: Pick<ContractLineItemFormValues.Create, "discountID" | "amount"> & {
		childContractLineItems: Pick<ContractLineItemFormValues.Create, "discountID" | "amount">[];
	},
) {
	let total = getSignedFormAmount(formValues);
	for (let i = 0; i < formValues.childContractLineItems.length; i++) {
		total += getSignedFormAmount(formValues.childContractLineItems[i]);
	}
	return total;
}

export function getSignedFormAmount(formValues: Pick<ContractLineItemFormValues.Base, "discountID" | "amount">) {
	const isDiscount = !!formValues.discountID;
	const amount = formValues.amount ?? 0;
	return isDiscount ? -1 * amount : amount;
}
